export function getStyles() {
  return {
    calenderWrapper: {
      position: 'absolute',
      zIndex: '1',
      background: 'white',
      boxShadow: 'rgb(0 0 0 / 13%) 0px 6.4px 14.4px 0px, rgb(0 0 0 / 11%) 0px 1.2px 3.6px 0px',
      padding: '12px',

      '& table': {
        marginBottom: '0px',
      },
      '& .single-month-calendar, & .calendar-month, & .calendar-year': {
        '& .navContainer': { display: 'flex' },
        '& .navContainer .prevMonth': { marginRight: 'auto' },
        '& .navContainer .prevMonth :hover': { cursor: 'pointer' },
        '& .navContainer .nextMonth': { marginLeft: 'auto' },
        '& .navContainer .nextMonth :hover': { cursor: 'pointer' },
        '& .navContainer .monthAndYear': {
          textAlign: 'center',
          fontWeight: '500',
          fontSize: '14px',
        },
        // fix https://msasg.visualstudio.com/Bing_Ads/_workitems/edit/3480161
        '& .navContainer .monthAndYear.monthYearButton': {
          fontWeight: '600',
        },
      },
      '& .single-month-calendar': {
        '& .table': { width: '200px', border: 'none', borderSpacing: 'unset' },
        '& th.weekday, .day': {
          textAlign: 'center',
          lineHeight: '15px',
          width: '28px',
        },
        '& .table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td': {
          padding: '0',
          paddingTop: '6px',
          paddingBottom: '6px',
          borderRadius: '2px',
          border: 'none',
        },
        '& .table > thead > tr > th span, .table > tbody > tr > th span, .table > tfoot > tr > th span, .table > thead > tr > td span, .table > tbody > tr > td span, .table > tfoot > tr > td span': {
          fontSize: '12px',
        },
        '& .table > thead > tr > th.weekday, .table > tbody > tr > th.weekday, .table > tfoot > tr > th.weekday, .table > thead > tr > td.weekday, .table > tbody > tr > td.weekday, .table > tfoot > tr > td.weekday': {
          fontSize: '12px',
          fontWeight: '400',
        },
        '& .dayWrapper.isInBounds.isInMonth': { backgroundColor: '#F3F2F1' },
        '& .dayWrapper.isInBounds.isInMonth:hover': {
          cursor: 'pointer',
          backgroundColor: '#EDEBE9',
        },
        '& .dayWrapper.isInSelectedRange.isInMonth': { backgroundColor: '#CBE7F2' },
        '& .dayWrapper.isInComparedRange.isInMonth': { backgroundColor: '#DFF6DD' },
        '& .dayWrapper.isSelectedRangeStartOrEnd.isInMonth': {
          backgroundColor: '#0078D4',
          color: '#fff',
        },
        '& .dayWrapper.isComparedRangeStartOrEnd.isInMonth': {
          backgroundColor: '#107C10',
          color: '#fff',
        },
        '& .dayWrapper.notInMonth': { color: '#A19F9D' },
        '& .dayWrapper.notInBounds': { color: '#ccc', backgroundColor: '#fff' },
        '& .dayWrapper.isToday.isInMonth': { border: '1px solid #999 !important' },
      },
    },
  };
}
